import { AppConfig } from "@/types/config";

let config: AppConfig | null;
config = null;
const configs = require.context(
  `./${process.env.VUE_APP_CONFIG}/`,
  false,
  /\.config\.json$/
);
// eslint-disable-next-line
configs.keys().forEach((key) => {
  const matched = key.includes(process.env.NODE_ENV as string);
  if (matched) {
    config = configs(key);
  }
});

export default config;
